export const cppTranslations = {
  en: {
    // Header
    curriculum: "Curriculum",
    features: "Features", 
    schedule: "Schedule",
    contact: "Contact",
    enrollNow: "Enroll Now",
    
    // Hero
    inPersonAnnouncement: "📍 IN-PERSON CLASSES IN AMMAN",
    heroTitle: "Master C++ Programming Step by Step",
    heroSubtitle: "Learn C++ from scratch in our Amman classroom. Our unique LEGO-style approach builds your programming skills block by block with hands-on problem solving.",
    viewSchedule: "View Schedule",
    lessons: "Lessons",
    problemsSolved: "Problems Solved",
    weeksDuration: "Weeks Duration", 
    studentsPerClass: "Students Per Class",
    smallClasses: "Small Classes",
    smallClassesDesc: "Maximum 10 students per class for personalized attention",
    flexibleSchedule: "Schedule",
    flexibleScheduleDesc: "Evening class available",
    
    // Curriculum
    completeCurriculumTitle: "Complete C++ Curriculum",
    completeCurriculumSubtitle: "Our comprehensive 12-week program takes you from complete beginner to confident C++ programmer. Each week builds on the previous - like stacking LEGO blocks to create something amazing.",
    week: "WEEK",
    clickToExpand: "Click to expand",
    clickToCollapse: "Click to collapse",
    problemSolving: "Problem Solving",
    problemSolvingWeek: "Practice problems and coding exercises to reinforce the concepts learned this week. Build real programs step by step!",
    legoLearning: "🧱 LEGO-Style Learning Approach",
    buildFoundation: "Build Foundation",
    buildFoundationDesc: "Start with basic blocks - syntax, variables, and simple operations",
    stackConcepts: "Stack Concepts", 
    stackConceptsDesc: "Each new concept connects perfectly to what you already know",
    createPrograms: "Problem Solving",
    createProgramsDesc: "Learn how to think and solve real-life problems step by step.",
    
    // Features
    whyChooseTitle: "Why Choose Our C++ Course?",
    whyChooseSubtitle: "Learn C++ programming in the heart of Amman with our proven step-by-step methodology. Perfect for absolute beginners who want to build a strong foundation.",
    stepByStepLearning: "Step-by-Step Learning",
    stepByStepLearningDesc: "Like building with LEGO blocks - each concept builds on the previous one",
    problemSolvingFocus: "Problem Solving Focus",
    problemSolvingFocusDesc: "50+ practical coding problems to strengthen your programming skills",
    inPersonClasses: "In-Person Classes",
    inPersonClassesDesc: "Face-to-face learning in Amman with direct instructor support",
    beginnerFriendly: "Beginner Friendly",
    beginnerFriendlyDesc: "No prior programming experience required - start from absolute zero",
    
    locationSchedule: "Location & Schedule",
    inPersonAmman: "In-Person Classes in Amman",
    courseDetails: "Course Details",
    completeProgramInfo: "Complete Program Information",
    reserveSpot: "Reserve Your Spot Now",
    
    problemSolvingApproach: "💡 Problem-Solving Approach",
    understand: "Understand",
    understandDesc: "Break down the problem into smaller, manageable pieces",
    plan: "Plan",
    planDesc: "Design your solution step-by-step using C++ concepts",
    code: "Code",
    codeDesc: "Implement your solution and test it thoroughly",
    handsOnProblems: "hands-on problems from basic to advanced level",
    programmingPhilosophy: '"Programming is learned by writing programs" - our philosophy in action',
    
    // Testimonials
    studentSuccessTitle: "Student Success Stories",
    studentSuccessSubtitle: "Hear from our students who transformed from complete beginners to confident C++ programmers in just 10 weeks of dedicated learning.",
    rating: "Rating",
    basedOnFeedback: "Based on feedback from 150+ students",
    courseCompletionRate: "Course Completion Rate",
    wouldRecommend: "Would Recommend",
    courseSuccessMetrics: "📊 Course Success Metrics",
    studentsGraduated: "Students Graduated",
    foundProgrammingJobs: "Found Programming Jobs",
    yearsTeaching: "Years Teaching",
    problemsSolvedTotal: "Problems Solved",
    
    // Contact
    readyToStartTitle: "Ready to Start Your C++ Journey?",
    readyToStartSubtitle: "Join our next batch and transform from complete beginner to confident C++ programmer. Classes are filling up fast in Amman!",
    getInTouch: "Get In Touch",
    phone: "Phone",
    email: "Email",
    location: "Location",
    contactViaWhatsApp: "Contact via WhatsApp",
    availableBatches: "Available Batches",
    maxStudents: "Max 10 students",
    starts: "Starts",
    registerNow: "Register Now",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    preferredBatch: "Preferred Batch",
    programmingExperience: "Programming Experience",
    questionsComments: "Questions or Comments",
    registerForCourse: "Register for Course",
    registrationFee: "Registration Fee",
    includesAllMaterials: "Includes all course materials, certificate, and lifetime support",
    
    // Programming Experience Options
    completeBeginner: "Complete Beginner",
    basicHtmlCss: "Basics",
    someProgramming: "Some Programming", 
    experiencedDeveloper: "I have experience with one or more programming languages",
    
    // Batch Options
    eveningBatch: "Evening Batch (Sat & Wed 6-8 PM)",
    //morningBatch: "Morning Batch (Tue & Thu 10-12 PM)",
    
    // Footer
    whatYouLearn: "What You'll Learn",
    cppBasics: "C++ Basics & Syntax",
    variablesDataTypes: "Variables & Data Types",
    controlStructures: "Control Structures",
    functionsArrays: "Functions & Arrays",
    problemSolvingFooter: "Problem Solving",
    realProjects: "Real Programming Projects",
    contactInfo: "Contact Info",
    currentClassSchedule: "📅 Current Class Schedule",
    open: "Open",
    fewSpotsLeft: "Few Spots Left",
    allRightsReserved: "All rights reserved",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    refundPolicy: "Refund Policy",
    locatedInAmman: "🏠 Located in the heart of Amman • 📱 WhatsApp support available"
  },
  ar: {
    // Header - Arabic
    curriculum: "المنهج",
    features: "المميزات",
    schedule: "الجدول",
    contact: "التواصل",
    enrollNow: "سجل الآن",
    
    // Hero - Arabic
    inPersonAnnouncement: "📍 حصص حضورية في عمان",
    heroTitle: "أتقن برمجة C++ خطوة بخطوة",
    heroSubtitle: "تعلم C++ من الصفر في فصولنا الدراسية في عمان. نهجنا الفريد على طراز الليجو يبني مهاراتك البرمجية كتلة تلو الأخرى مع حل المشكلات العملي.",
    viewSchedule: "عرض الجدول",
    lessons: "دروس",
    problemsSolved: "مسائل محلولة",
    weeksDuration: "أسابيع المدة",
    studentsPerClass: "طلاب في الصف",
    smallClasses: "صفوف صغيرة",
    smallClassesDesc: "حد أقصى 20 طالب لكل صف للاهتمام الشخصي",
    flexibleSchedule: "جدول", 
    flexibleScheduleDesc: "متاح دفعات صباحية ومسائية",
    
    // Curriculum - Arabic
    completeCurriculumTitle: "منهج C++ الكامل",
    completeCurriculumSubtitle: "برنامجنا الشامل لمدة 12 أسبوع يأخذك من مبتدئ كامل إلى مبرمج C++ واثق. كل أسبوع يبني على السابق - مثل تكديس قطع الليجو لإنشاء شيء مذهل.",
    week: "الأسبوع",
    clickToExpand: "انقر للتوسيع",
    clickToCollapse: "انقر للتصغير", 
    problemSolving: "حل المشكلات",
    problemSolvingWeek: "مشكلات تطبيقية وتمارين برمجية لتعزيز المفاهيم المتعلمة هذا الأسبوع. ابن برامج حقيقية خطوة بخطوة!",
    legoLearning: "🧱 نهج التعلم على طراز الليجو",
    buildFoundation: "بناء الأساس",
    buildFoundationDesc: "ابدأ بالكتل الأساسية - الصيغة والمتغيرات والعمليات البسيطة",
    stackConcepts: "تكديس المفاهيم",
    stackConceptsDesc: "كل مفهوم جديد يتصل بشكل مثالي مع ما تعرفه بالفعل",
    createPrograms: "إنشاء البرامج",
    createProgramsDesc: "ادمج جميع الكتل لبناء تطبيقات كاملة وعاملة",
    
    // Features - Arabic
    whyChooseTitle: "لماذا تختار دورة C++ الخاصة بنا؟",
    whyChooseSubtitle: "تعلم برمجة C++ في قلب عمان بمنهجيتنا المثبتة خطوة بخطوة. مثالية للمبتدئين المطلقين الذين يريدون بناء أساس قوي.",
    stepByStepLearning: "التعلم خطوة بخطوة",
    stepByStepLearningDesc: "مثل البناء بقطع الليجو - كل مفهوم يبني على السابق",
    problemSolvingFocus: "التركيز على حل المشكلات",
    problemSolvingFocusDesc: "أكثر من 100 مسألة برمجية عملية لتقوية مهاراتك البرمجية",
    inPersonClasses: "حصص حضورية",
    inPersonClassesDesc: "تعلم وجهاً لوجه في عمان مع دعم مباشر من المدرس",
    beginnerFriendly: "مناسب للمبتدئين",
    beginnerFriendlyDesc: "لا حاجة لخبرة برمجية مسبقة - ابدأ من الصفر المطلق",
    
    locationSchedule: "الموقع والجدول",
    inPersonAmman: "حصص حضورية في عمان",
    courseDetails: "تفاصيل الدورة",
    completeProgramInfo: "معلومات البرنامج الكاملة",
    reserveSpot: "احجز مقعدك الآن",
    
    problemSolvingApproach: "💡 نهج حل المشكلات",
    understand: "الفهم",
    understandDesc: "تقسيم المشكلة إلى قطع أصغر وقابلة للإدارة",
    plan: "التخطيط",
    planDesc: "تصميم حلك خطوة بخطوة باستخدام مفاهيم C++",
    code: "البرمجة",
    codeDesc: "تنفيذ حلك واختباره بدقة",
    handsOnProblems: "مسألة عملية من المستوى الأساسي إلى المتقدم",
    programmingPhilosophy: '"البرمجة تُتعلم بكتابة البرامج" - فلسفتنا في العمل',
    
    // Testimonials - Arabic
    studentSuccessTitle: "قصص نجاح الطلاب",
    studentSuccessSubtitle: "استمع من طلابنا الذين تحولوا من مبتدئين كاملين إلى مبرمجي C++ واثقين في 12 أسبوع فقط من التعلم المكرس.",
    rating: "التقييم",
    basedOnFeedback: "بناءً على تقييمات أكثر من 150 طالب",
    courseCompletionRate: "معدل إكمال الدورة",
    wouldRecommend: "ينصحون بها",
    courseSuccessMetrics: "📊 مقاييس نجاح الدورة",
    studentsGraduated: "طلاب تخرجوا",
    foundProgrammingJobs: "وجدوا وظائف برمجية",
    yearsTeaching: "سنوات التدريس",
    problemsSolvedTotal: "مسائل محلولة",
    
    // Contact - Arabic
    readyToStartTitle: "مستعد لبدء رحلة C++ الخاصة بك؟",
    readyToStartSubtitle: "انضم إلى دفعتنا القادمة وتحول من مبتدئ كامل إلى مبرمج C++ واثق. الصفوف تمتلئ بسرعة في عمان!",
    getInTouch: "تواصل معنا",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    location: "الموقع",
    contactViaWhatsApp: "تواصل عبر الواتساب",
    availableBatches: "الدفعات المتاحة",
    maxStudents: "حد أقصى 20 طالب",
    starts: "تبدأ",
    registerNow: "سجل الآن",
    fullName: "الاسم الكامل",
    emailAddress: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    preferredBatch: "الدفعة المفضلة",
    programmingExperience: "الخبرة البرمجية",
    questionsComments: "أسئلة أو تعليقات",
    registerForCourse: "سجل في الدورة",
    registrationFee: "رسوم التسجيل",
    includesAllMaterials: "يشمل جميع المواد الدراسية والشهادة والدعم مدى الحياة",
    
    // Programming Experience Options - Arabic
    completeBeginner: "مبتدئ كامل",
    basicHtmlCss: "أساسي (HTML/CSS)",
    someProgramming: "بعض البرمجة",
    experiencedDeveloper: "مطور متمرس",
    
    // Batch Options - Arabic
    eveningBatch: "الدفعة المسائية (السبت والأربعاء 6-8 مساءً)",
    morningBatch: "الدفعة الصباحية (الثلاثاء والخميس 10-12 صباحاً)",
    
    // Footer - Arabic
    whatYouLearn: "ما ستتعلمه",
    cppBasics: "أساسيات C++ والصيغة",
    variablesDataTypes: "المتغيرات وأنواع البيانات",
    controlStructures: "هياكل التحكم",
    functionsArrays: "الوظائف والمصفوفات",
    problemSolvingFooter: "حل المشكلات",
    realProjects: "مشاريع برمجية حقيقية",
    contactInfo: "معلومات التواصل",
    currentClassSchedule: "📅 جدول الصفوف الحالي",
    open: "متاح",
    fewSpotsLeft: "مقاعد قليلة متبقية",
    allRightsReserved: "جميع الحقوق محفوظة",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الخدمة",
    refundPolicy: "سياسة الاسترداد",
    locatedInAmman: "🏠 موقع في قلب عمان • 📱 دعم الواتساب متاح"
  }
};